import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { InstacartAccount, InstacartAccountInput } from '@/models/instacartAccount';

export const createInstacartAccount = async (data: InstacartAccountInput): Promise<InstacartAccount> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateInstacartAccount($data: InstacartAccountInputType!) {
        createInstacartAccount(data: $data) {
          id
          isActive
          isClosed
          isEbtAccount
          user
          email
          phoneNumber
          country
          cookie
          csrfToken
          notes
          lastUsedAt
          lastLoginSuccess
          lastLoginFailure
          isLocked
          lockedAt
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createInstacartAccount!;
};
